import React, { PureComponent, ReactNode } from "react";
import "./MonoSpacedTextColumn.css";

interface Props {
  lines: Array<string>;
  uniqueId: string;
}
interface State {}

class MonoSpacedTextColumn extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render(): ReactNode {
    return (
      <div className="mono-spaced-text-column">
        {this.props.lines.map((line, index) => {
          const key = `mstc${this.props.uniqueId}-${index}`;
          return (
            <div key={key} className="mono-spaced-text-line">
              {line}
            </div>
          );
        })}
      </div>
    );
  }
}

export default MonoSpacedTextColumn;
